import { isAcceptanceTest } from 'ContentEditorUI/utils/env';
import { getExperimentTreatments } from 'EmailEditorUI/hooks/experiments/useTreatments';
import { getHasFreeEmail } from 'EmailEditorUI/redux/selectors/AuthSelectors';
export const MC0653_TREATMENT_KEY = 'mc-0653';
export const MC0653_GROUP_PARAMETER = 'group';
export const MC0653_GROUP_VARIATION = 'variation';
export const getIsMc0653Variation = state => {
  if (isAcceptanceTest()) {
    return undefined;
  }
  const {
    treatments
  } = getExperimentTreatments(state);
  if (!treatments || !treatments[MC0653_TREATMENT_KEY]) {
    return undefined;
  }
  const treatment = treatments[MC0653_TREATMENT_KEY].parameters[MC0653_GROUP_PARAMETER];
  const isFreeEmail = getHasFreeEmail(state);
  return treatment === MC0653_GROUP_VARIATION && isFreeEmail;
};